// import * as Sentry from '@sentry/browser';

import { setOrderInitial } from './order/actions';
import PriceSelect from './price/price-select/index-lazy';
import { renderer } from './utils/renderer';
import AccountMini from './account-mini';
import CompanyDetails from './company-details';
import Order from './order';
import SocialLogin from './social-login';

import './styles/global.css';

const components = [
  ['[data-account]', AccountMini],
  ['[data-price-select]', PriceSelect],
  ['[data-company]', CompanyDetails],
  ['[data-social-login]', SocialLogin],
  ['[data-order]', Order],
];

window.bbSetOrderInitial = setOrderInitial;

/**
 * XXX runtime, side-effect window
 */
components.forEach(opts => renderer(...opts));

// // eslint-disable-next-line import/namespace
// Sentry.init({
//   dsn: 'https://cf07fb37885c453282dc3b1783b32206@sentry.zae.cc/52',
//   release: `blocks-critical-writing@${BB_VERSION}`,
//   integrations: [Sentry.browserTracingIntegration()],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for tracing.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });
